import { useState, useRef } from "react";
import axios from "axios";
import { useDropzone } from "react-dropzone";

import { postMethod } from "../api/HTTPServices";
import { ErrorData } from "../helpers/helper";

export const useFileUpload = (
  AudienceID,
  handleClose,
  roomToken,
  attachType,
  successFullUploadCallBack
) => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    multiple: false,
    maxSize: 10400000,
  }); // max file size: 10 MB
  const [source] = useState(axios.CancelToken.source());
  const [description, setDescription] = useState("");
  const [success, setSuccess] = useState([]);
  const [failed, setFailed] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [currentUploadFile, setCurrentUploadFile] = useState("");
  const [process, setProcess] = useState(0);
  const descriptionInputRef = useRef(null);

  let attachTypeData = attachType;

  const upload = () => {
    setUploading(true);
    acceptedFiles.forEach((file, index) => {
      if (success.indexOf(file.name) !== -1) {
        return;
      }
      setCurrentUploadFile(file.name);
      var data = new FormData();
      data.append("message", description);
      data.append("audience", AudienceID);

      if (attachTypeData == "prescription") {
        data.append("type", "prescriptionFile");
      } else {
        data.append("type", "dossierFile");
      }

      data.append("file", file);
      data.append("room_token", roomToken);

      const RequestService = postMethod(
        "chat",
        data,
        "true",
        "post",
        "false",
        "",
        false,
        (ProgressEvent) => {
          setProcess((ProgressEvent.loaded / ProgressEvent.total) * 100);
        },
        () => {
          setFailed([...failed, file.name]);
          setUploading(false);
          ErrorData("اپلود فایل با خطا مواجه شد. لطفا دوباره تلاش کنید.");
        },
        source.token
      );
      RequestService.then(function (response) {
        console.log("fuck ", response)
        if (response) {
          setSuccess([...success, file.name]);
          successFullUploadCallBack(response);
        }
      }).catch((err) => {
        console.log("fuck ", err)
      });
    });
  };

  const close = () => {
    source.cancel("upload operation canceled by user");
    handleClose();
  };

  return {
    getRootProps,
    getInputProps,
    setDescription,
    setCurrentUploadFile,
    upload,
    close,
    description,
    uploading,
    currentUploadFile,
    process,
    acceptedFiles,
    success,
    failed,
    descriptionInputRef,
  };
};
